import { cmxTypeguards, codeBenchActions, commonEnums } from '@codametrix/ui-common';
import { getPrevOrNextCase, launchWorkitemInAmplify } from '../../actions/cases.action';
import { middleWareWrapper } from './middleware-utils';
const { loadNextOrPreviousCase, loadWorkitemInAmplify } = codeBenchActions;
const serviceDeskProcessor = (api, next, action)=>{
    if (cmxTypeguards.isReduxAction(action) && action.type === loadNextOrPreviousCase.type && action.payload) {
        const status = action.payload.status?.toUpperCase();
        const cursorAPIPayload = action.payload?.cursorAPIPayload;
        const cursorAPIContext = cursorAPIPayload?.cursorAPIContext;
        if (status === commonEnums.FeedbackMeta.SUCCESS) {
            if (cursorAPIContext?.servicedeskMode && cursorAPIContext?.workitemId && cursorAPIContext?.worklistContext?.query != null) {
                api.dispatch(getPrevOrNextCase(cursorAPIPayload));
            }
        }
    }
    if (action.type === loadWorkitemInAmplify.type) {
        const launchConfig = action.payload;
        api.dispatch(launchWorkitemInAmplify(launchConfig));
    }
    return next(action);
};
export const serviceDeskMiddleware = middleWareWrapper(serviceDeskProcessor);
